import { render, staticRenderFns } from "./tareTask.vue?vue&type=template&id=4d8da0d6&scoped=true"
import script from "./tareTask.vue?vue&type=script&lang=js"
export * from "./tareTask.vue?vue&type=script&lang=js"
import style0 from "./tareTask.vue?vue&type=style&index=0&id=4d8da0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8da0d6",
  null
  
)

export default component.exports